module.exports = __webpack_public_path__ + "static/img/goods_1.856dd77.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/goods_1.png
// module id = crdM
// module chunks = 37